import React from 'react';
import { GeneralContext } from '../../App';
import { Video, Typography } from '../../components';

export default function Kennismaking(props) {
    const { hasPhone, hasTablet } = React.useContext(GeneralContext);
    return (
        <div style={{ padding: hasPhone ? '10vh 0' : '5vh 0', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', position: 'relative', overflow: 'hidden' }}>
            <Typography type='h1' style={{ margin: '2vw', color: '#032d34', whiteSpace: 'pre' }}>Kennismaking</Typography>
            <div style={{  maxWidth: hasPhone ? '100vw' : '90vw', zIndex: 3, margin: '3vw' }}>
                <Video videoId='lTfa8PbpG_U' />
            </div>
        </div>
    )
}
